import { Upload } from 'antd';
import styled from 'styled-components';

export const StyledDragger = styled(Upload.Dragger)`
    background-color: var(--gray-3) !important;

    &:hover {
        border-color: var(--brand-6) !important;
        border-radius: 2px;
    }

    &:focus-within {
        border-color: var(--brand-7) !important;
        border-style: dashed;
    }

    &.ant-upload-disabled:hover {
        border-color: var(--gray-5) !important;
    }
`;
